import HearthBeatLoader from './hb-loader';

export default HearthBeatLoader;
